import React, { useCallback, useMemo } from 'react';
import Searcher from './Searcher';
import { generateColumnsDefaultConfiguration } from '../../../../../../components/dataGrid/columnHelpers';
import { adaptPacientesArray, GET_PACIENTES_PAGINATED_RECLAMOS } from '../../../../../../data/graphQL/queries/Reclamos/getAllPacientes';

const PacienteField = ({
    onChange,
    idPaciente,
    disabled,
    idDelegacion
}) => {

    const CONFIGURATED_COLUMNS = useMemo(() => (generateColumnsDefaultConfiguration(columns)), [columns]);

    const getSearchParams = useCallback((textValue) => {
        const filterDelegacion = idDelegacion ? {
            idDelegacion: { eq: idDelegacion }
        } : {};

        const searchParams = {
            and: [filterDelegacion]
        };

        if (textValue) {
            searchParams.and.push({
                or: [
                    { nombre: { contains: textValue } },
                    { apellido: { contains: textValue } },
                    { numeroDocumento: { contains: textValue } }
                ]
            });
        }

        return searchParams;
    }, [idDelegacion]);

    const handleRowClick = (row) => {
        onChange('idPaciente', row?.idPaciente);
    }

    const getEntityValue = (row) => {
        const value = !!row ? `${row.nombre} ${row.apellido}` : null
        return value;
    }

    return <Searcher
        displayName='Paciente'
        titleModal='Seleccionar paciente'
        entityName='allPatientsWithApprovedEvaluations'
        entityId='idPaciente'
        entityIdValue={idPaciente}
        columns={CONFIGURATED_COLUMNS}
        query={GET_PACIENTES_PAGINATED_RECLAMOS}
        adapter={adaptPacientesArray}
        getSearchParams={getSearchParams}
        onRowClick={handleRowClick}
        getEntityValue={getEntityValue}
        disabled={disabled}
    />
}

export default PacienteField;

const columns = [
    {
        field: 'nombre',
        headerName: 'Nombre',
        flex: 2
    },
    {
        field: 'apellido',
        headerName: 'Apellido',
        flex: 1.5
    },
    {
        field: 'idTipoDocumento',
        headerName: 'T. de Documento',
        flex: 1,
    },
    {
        field: 'numeroDocumento',
        headerName: 'Número de DNI',
        flex: 1,
    },
    {
        field: 'sexo',
        headerName: 'Sexo',
        flex: 1
    },
    {
        field: 'fechaNacimiento',
        headerName: 'Fecha Nacimiento',
        type: 'date',
        flex: 1,
    },
];